import BaseDropdown from './dropdown';

class SortDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'sorts';
    // List item can be targeted by the identifier, e.g. $('.dropdown-item.price-desc')
    this.identifierField = 'identifier';
    this.hasSearch = false;
    this.dropdownDiv = null;

    this.state = {
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
      sorts: this.props.items,
    };
  }

  componentDidUpdate() {
    /*
     * If this.props.items are updated by parent after this initializes,
     * we need to update the label.
     */
    const currentItem = this.props.items.find(item => item.selected);
    if (currentItem.label !== this.state.label) {
      this.setState({ label: currentItem.label });
    }
  }

  select(index, event) {
    const updatedItems = this.props.items.map((option, idx) => {
      return { ...option, selected: idx === index };
    });

    const selectedOption = updatedItems.find(option => option.selected);
    const gaLabel = `${this.props.gaEvent.label} ${selectedOption.label}`;
    this.AnalyticService.trackEvent(this.props.gaEvent.category, 'Execute', gaLabel);

    this.setState({
      sorts: updatedItems,
      label: this.getLabel(updatedItems),
    });
    this.props.updateSortOptions(updatedItems);
  }
}

export default SortDropdown;
